import Button from "@mui/material/Button";
import styled from "styled-components";

export const CreateKeyPairButton = styled(Button)`
  margin-right: ${({ theme }) => theme.spacing(2)};
`;
